module.exports = __webpack_public_path__ + "./images/rider.84ac1e.svg";